export const pageNavigation_actionType = {
    ACCOUNT_REQUEST_FORM : "Account Request Form",
    CREATE_USER_ACCOUNT : "Create User Account",
    USER_DETAILS : "User Details",
    USER_ROLES : "User Roles",
    SUMMARY: "Summary",
    MODIFY_USER_ACCOUNT: "Modify User Account"
};